import React from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";

const NoAccess = (props) => {
	const { message } = props;
	return (
		<React.Fragment>
			<CssBaseline />
			<Container maxWidth="sm">
				<Typography variant="h3" align="center">
					Access denied!
				</Typography>
				<Typography variant="h5" align="center">
					{message}
				</Typography>
			</Container>
		</React.Fragment>
	);
};

export default NoAccess;

NoAccess.propTypes = {
	message: PropTypes.string.isRequired,
};
